import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { useTranslation } from "react-i18next";
import { post } from "../../../../../utils/helpers/api";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

function CreateExpenseVendorModal({ isOpen, toggle, onSave, vendorToEdit }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [vendorData, setVendorData] = useState({
    name: vendorToEdit?.name || null,
    description: vendorToEdit?.description || null
  });

  useEffect(() => {
    if(vendorToEdit) {
      setVendorData({
        name: vendorToEdit?.name || null,
        description: vendorToEdit?.description || null
      });
    } else {
      setVendorData({
        name: null,
        description: null
      });
    }
  }, [vendorToEdit, isOpen]);

  const saveVendor = async () => {
    setSaveLoading(true);
    const url = vendorToEdit ? `/accounting/expense-vendors/update/${vendorToEdit.id}` : '/accounting/expense-vendors/store';
    const data = await post(url, vendorData)
    if(data?.success) {
      onSave();
      toggle();
      toast.success(vendorToEdit ? t('accounting.vendorUpdated') : t('accounting.vendorCreated'));
    } else {
      toast.error(data?.message || t('common.somethingWentWrong'));
      toggle();
    }
    setSaveLoading(false);
  }

  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>{vendorToEdit ? t('accounting.editExpenseVendor') : t('accounting.newExpenseVendor')}</ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input
            value={vendorData?.name}
            onChange={e => setVendorData({...vendorData, name: e.target.value})}
          />
        </FormGroup>
        <div>
          <Label>{t('common.description')}: </Label>
          <Input 
            type="textarea" 
            value={vendorData?.description}
            onChange={e => setVendorData({...vendorData, description: e.target.value})}
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <DefaultButton color="secondary" size="sm" outline onClick={toggle}>{t('common.cancel')}</DefaultButton>
        <DefaultButton 
          color="primary" 
          size="sm" 
          onClick={saveVendor}
          loading={saveLoading}
          disabled={saveLoading || !vendorData?.name}
        >{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default CreateExpenseVendorModal;